import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBoxLabel } from '@ecp/common/src/text/TextBoxLabel';

const FindInputForm = ({ children, labelText, labelTextProps }) => {
  return (
    <FindInputFormWrapper>
      <FindInputLabel {...labelTextProps}>{labelText}</FindInputLabel>
      {children}
    </FindInputFormWrapper>
  );
};

export default FindInputForm;
FindInputForm.propTypes = {
  children: PropTypes.any,
  labelText: PropTypes.string,
  labelTextProps: PropTypes.object,
};

const FindInputFormWrapper = styled(FlexBoxColumn)`
  width: 320px;
  align-items: flex-start;
  justify-content: center;
`;

const FindInputLabel = styled(TextBoxLabel)`
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  align-items: flex-start;
  ${({ labelTextProps }) => labelTextProps};
`;
